/** Paths that may return 401/403 without meaning "logged-in session expired". */
const PUBLIC_AUTH_PATH_SUFFIXES = [
  '/auth/login',
  '/auth/me',
  '/auth/logout',
  '/auth/user/verify-email-token',
  '/auth/user/verify-mobile-token',
  '/auth/user/verify-password-reset-token',
  '/auth/user/reset-password',
  '/auth/user/change-password',
  '/auth/user/registration',
  '/auth/user/send-mobile-token',
];

export function isPublicAuthRequest(config) {
  const url = config?.url;
  if (!url || typeof url !== 'string') {
    return false;
  }
  return PUBLIC_AUTH_PATH_SUFFIXES.some(suffix => url.includes(suffix));
}

/**
 * Whether a failed response should clear the client session.
 * Cookie auth uses 401 for unauthenticated; 403 is often "forbidden", not expired.
 */
export function shouldClearSessionOnAuthError(status, config) {
  if (status !== 401) {
    return false;
  }
  if (config?.skipAuthLogout) {
    return false;
  }
  if (isPublicAuthRequest(config)) {
    return false;
  }
  return true;
}
